module.exports = __webpack_public_path__ + "img/extended.122f8b9c.png";